import { defineMessages } from 'react-intl-next';
export default defineMessages({
  sitePickerLabel: {
    id: 'ai-mate.conversation-assistant-site-picker.site-picker-label',
    defaultMessage: 'Switch site',
    description: 'Label for conversation assistant site picker'
  }
});